import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-detail-dialog',
  standalone: false,
  templateUrl: './error-detail-dialog.component.html',
  styleUrl: './error-detail-dialog.component.css'
})
export class ErrorDetailDialogComponent {
  errorMessage: string | null;
  taskName: string;
  copied = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { errorMessage: string; taskName?: string },
    private dialogRef: MatDialogRef<ErrorDetailDialogComponent>
  ) {
    this.errorMessage = data.errorMessage || null;
    this.taskName = data.taskName ?? '';
  }

  copy(): void {
    navigator.clipboard.writeText(this.errorMessage ?? '');
    this.copied = true;
    setTimeout(() => this.copied = false, 2000);
  }

  close(): void {
    this.dialogRef.close();
  }
}
